import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import NavBarDirective from './directives/NavBarDirective';
import NavBarItems from './directives/NavBarItems';
import mediaSidebarConfig from 'portal/config/media-sidebar-config';
import TransactionWizardTitleGateway from './components/transactionWizardTitle';
import WizardSidebarAdditionalGateway from './directives/wizardSidebarAdditional';
import ConfirmationBackButtonGateway from './components/confirmationBackButton';
import _ from 'underscore';

import 'edge/platform/widgets/pagestructure/module';
import 'edge/gateway/app';
import 'edge/faq/app';
import 'conditional?if=gatewayclaims&equals=true!edge/fnol/app';
import 'conditional?if=gatewayclaims&equals=true!edge/claim/app';
import 'edge/billing/app';
import 'conditional?if=gatewayquoteandbind&equals=true!edge/quoteandbind/app';
import 'edge/endorsement/app';
import 'gw-portals-policytransaction-angular';
import 'edge/policy/app';
import 'edge/platform/widgets/icon/module';
import 'conditional?if=journey&equals=true!edge/journey/app';
import SetVersionDocumentTitle from 'gw-portals-platform-angular/versionName/SetVersionDocumentTitle';
import 'styles-portal/sass/modules.scss';
import 'gw-portals-renewal-angular';

var modules = ['edge.platform.widgets.pagestructure', 'edge.platform.widgets.icon', 'edge.gateway.app', 'edge.billing.app', 'edge.faq.app', 'ui.router', 'edge.endorsement.app', 'edge.transaction.app', 'edge.policy.app', 'edge.renewal.app'];

var applicationFeatures = ApplicationFeatures.getAllFeatures();
if (applicationFeatures.gatewayclaims === 'true') {
    modules.push('edge.fnol.app');
    modules.push('edge.claim.app');
}
if (applicationFeatures.gatewayquoteandbind === 'true') {
    modules.push('edge.quoteandbind.app');
}
if (applicationFeatures.journey === 'true') {
    modules.push('edge.journey.app');
}

export default angular.module('portal.app', modules).factory('NavBarItems', NavBarItems).directive('gwPortalNavBar', NavBarDirective).factory('MEDIA_SIDEBAR_CONFIGURATION', mediaSidebarConfig).config(['FaqServiceProvider', 'FAQ_CONFIG', 'USER_INFO', '$provide', function (FaqServiceProvider, FAQ_CONFIG, USER_INFO) {
    if (USER_INFO().userType === 'producer') {
        FaqServiceProvider.setSections(FAQ_CONFIG.agent.sections);
    } else {
        FaqServiceProvider.setSections(FAQ_CONFIG.underwriter.sections);
    }
}]).config(['$provide', function ($provide) {
    // Override the default gw-transaction-wizard-title
    $provide.decorator('gwTransactionWizardTitleDirective', ['$delegate', function ($delegate) {
        return [_.extend($delegate[0], TransactionWizardTitleGateway)];
    }]);
}]).config(['$provide', function ($provide) {
    // Override the default gw-wizard-sidebar-additional
    $provide.decorator('gwWizardSidebarAdditionalDirective', ['$delegate', function ($delegate) {
        return [_.extend($delegate[0], WizardSidebarAdditionalGateway)];
    }]);
}]).config(['$provide', function ($provide) {
    // Override the default gw-fnol-confirmation-back-button
    $provide.decorator('gwFnolConfirmationBackButtonDirective', ['$delegate', function ($delegate) {
        return [_.extend($delegate[0], ConfirmationBackButtonGateway)];
    }]);
}])

/* .config(['$compileProvider', 'IS_PRODUCTION_BUILD', function ($compileProvider, IS_PRODUCTION_BUILD) {
    if (IS_PRODUCTION_BUILD) {
        $compileProvider.debugInfoEnabled(false);
    }
}]) */

.config(['$logProvider', 'IS_PRODUCTION_BUILD', function ($logProvider, IS_PRODUCTION_BUILD) {
    if (IS_PRODUCTION_BUILD) {
        $logProvider.debugEnabled(false);
    }
}]).run(['$translate', function ($translate) {
    SetVersionDocumentTitle({
        $translate: $translate,
        // "portal.app.versionName.title[.${VERSION}]" l10n ID (with a version, if available for the app) will be used
        translationIdBase: 'portal.app.versionName.title'
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./app/js/portal/app.js
// module id = 1312
// module chunks = 0